import { combineReducers } from 'redux';
import { reducers as splitAuthReducers } from 'split-auth/build/redux';

import dashboard from './dashboard/reducers';
import home from './home/sections/reducers';
import performanceSnapshot from './home/performanceSnapshot/reducers';
import newArrivals from './home/newArrivals/reducers';
import recommendedCreators from './home/recommendedCreators/reducers';
import topPerformers from './home/topPerformers/reducers';

import merchants from './merchants/reducers';
import merchantsCreate from './merchantsCreate/reducers';
import merchantsVerify from './merchantsVerify/reducers';
import merchantsEdit from './merchantsEdit/reducers';
import analyticsLinksReport from './analyticsLinksReport/reducers';
import analyticsCampaignModifiers from './analyticsCampaignModifiers/reducers';
import analyticsUsersReport from './analyticsUsersReport/reducers';
import creatorDetails from './creatorObject/creatorDetails/reducers';
import chatCreatorDetails from './creatorObject/chatCreatorDetails/reducers';
import similarCreators from './creatorObject/similarCreators/reducers';
import creatorSignals from './creatorObject/creatorSignals/reducers';
import creatorMonthlySales from './creatorObject/creatorMonthlySales/reducers';
import creatorNotes from './creatorObject/creatorNotes/reducers';
import discover from './discover/reducers';
import discoverBrands from './discoverBrands/reducers';
import discoverCategories from './discoverCategories/reducers';
import discoverLinkCategories from './discoverLinkCategories/reducers';
import dataExports from './dataExports/reducers';
import members from './members/reducers';
import invitations from './invitations/reducers';
import membersInvite from './membersInvite/reducers';
import organizationContact from './organizationContact/reducers';
import account from './account/reducers';
import accountNameEdit from './accountNameEdit/reducers';
import accountEmailEdit from './accountEmailEdit/reducers';
import accountPhoneEdit from './accountPhoneEdit/reducers';
import accountPhoneVerify from './accountPhoneVerify/reducers';
import accountPasswordReset from './accountPasswordReset/reducers';
import help from './help/reducers';
import notifications from './notifications/reducers';
import swagger from './swagger/reducers';
import settings from './settings/reducers';
import layout from './layout/reducers';
import aiAssistant from './aiAssistant/reducers';
import aiChatToken from './aiChatToken/reducers';
import aiPromptSuggestions from './aiPromptSuggestions/reducers';
import pricingModal from './pricingModal/reducers';
import acceptInvitationSignUp from './acceptInvitationSignUp/reducers';
import avatar from './avatar/reducers';
import referralsLink from './referralsLinks/reducers';
import referralsConnections from './referralsConnections/reducers';
import referralsInvite from './referralsInvite/reducers';
import stripeBilling from './stripeBilling/reducers';
import verifiedDomains from './verifiedDomains/reducers';
import getUnmaskingConnection from './unmasking/connection/reducers';
import getUnmaskingConnections from './unmasking/connectionsList/reducers';
import getUnmaskingInvitation from './unmasking/invitation/reducers';
import getUnmaskingInvitations from './unmasking/invitationsList/reducers';
import withdrawUnmaskingInvitation from './unmasking/invitationWithdraw/reducers';
import sendUnmaskingInvitation from './unmasking/invitationSend/reducers';
import sendUnmaskingInvitationBulk from './unmasking/invitationSendBulk/reducers';

import getRegularusersGroups from './campaigns/groups/list/reducers';
import createRegularusersGroup from './campaigns/groups/create/reducers';
import updateRegularusersGroup from './campaigns/groups/update/reducers';
import deleteRegularusersGroup from './campaigns/groups/delete/reducers';
import getRegularusersGroup from './campaigns/groups/get/reducers';
import getAssignments from './campaigns/assignments/list/reducers';
import getAssignment from './campaigns/assignments/get/reducers';
import createAssignment from './campaigns/assignments/create/reducers';
import checkAssignmentBalance from './campaigns/assignments/checkBalance/reducers';
import updateAssignment from './campaigns/assignments/update/reducers';
import deleteAssignment from './campaigns/assignments/delete/reducers';
import archiveAssignment from './campaigns/assignments/archive/reducers';
import publishAssignment from './campaigns/assignments/publish/reducers';
import uniqueAssignmentName from './campaigns/assignments/uniqueName/reducers';
import getAssignmentSummary from './campaigns/assignments/summary/reducers';
import getAssignmentCreatorsPerformance from './campaigns/assignments/creatorsPerformance/reducers';
import baseCommissionRate from './baseCommissionRate/reducers';
import networkMerchant from './networkMerchant/reducers';
import getNetworkOrders from './networkOrders/list/reducers';
import getNetworkOrdersSummary from './networkOrders/summary/reducers';
import networkOrderDetail from './networkOrders/detail/reducers';
import commissionRules from './commissionRules/reducers';

import getSendbirdToken from './sendbird/token/reducers';
import createSendbirdGroup from './sendbird/groupCreate/reducers';
import sendbirdUnreadMessages from './sendbird/unreadMessages/reducers';

import getPromotions from './promotions/list/reducers';
import createPromotion from './promotions/create/reducers';
import getPromotion from './promotions/update/reducers';
import updatePromotion from './promotions/update/reducers';
import deletePromotion from './promotions/delete/reducers';

import campaignCreateFlow from './campaigns/createFlow/reducers';
import campaignEditFlow from './campaigns/editFlow/reducers';

import getMyCreatorsConnectedList from './myCreators/creators/connectedList/reducers';
import getMyCreatorsConnectedListScroll from './myCreators/creators/connectedListScroll/reducers';

import getMyCreatorsGroupsList from './myCreators/groupsList/reducers';

import createGroup from './myCreators/regularGroup/groupCreate/reducers';
import updateGroup from './myCreators/regularGroup/groupUpdate/reducers';
import groupFlow from './myCreators/regularGroup/groupFlow/reducers';
import deleteGroup from './myCreators/regularGroup/groupDelete/reducers';
import addGroupUsers from './myCreators/regularGroup/groupUsersAdd/reducers';
import getGroupUsersList from './myCreators/regularGroup/groupUsersList/reducers';
import removeGroupUsers from './myCreators/regularGroup/groupUsersRemove/reducers';

import createSmartGroup from './myCreators/smartGroup/groupCreate/reducers';
import updateSmartGroup from './myCreators/smartGroup/groupUpdate/reducers';
import refreshSmartGroup from './myCreators/smartGroup/groupRefresh/reducers';
import smartGroupFlow from './myCreators/smartGroup/groupFlow/reducers';
import deleteSmartGroup from './myCreators/smartGroup/groupDelete/reducers';

import batchMessage from './batchMessage/reducers';

import sendSendbirdBatchMessage from './sendbird/batchMessage/send/reducers';
import getSendbirdBatchMessageInfo from './sendbird/batchMessage/info/reducers';
import retrySendbirdBatchMessage from './sendbird/batchMessage/retry/reducers';
import getSendbirdBatchMessages from './sendbird/batchMessage/list/reducers';

import getBatchMessageVariables from './sendbird/variables/reducers';

import createBatchMessageTemplate from './sendbird/templates/create/reducers';
import updateBatchMessageTemplate from './sendbird/templates/update/reducers';
import removeBatchMessageTemplate from './sendbird/templates/remove/reducers';
import getBatchMessageTemplates from './sendbird/templates/list/reducers';

import performanceLinks from './performance/links/reducers';
import performanceTags from './performance/tags/reducers';
import performanceCreators from './performance/creators/reducers';
import performanceExports from './performance/exports/reducers';
import performanceSummaryCards from './performance/summaryCards/reducers';
import performanceSummaryChart from './performance/summaryChart/reducers';

import createShopifyToken from './shopify/createToken/reducers';
import getShopifyTokens from './shopify/getTokens/reducers';
import getShopifyToken from './shopify/getToken/reducers';
import getShopifyStatus from './shopify/status/reducers';
import getShopifyProducts from './shopify/getProducts/reducers';
import getShopifyCollections from './shopify/getCollections/reducers';
import getShopifyProductTypes from './shopify/getProductTypes/reducers';
import getShopifyCollectionProducts from './shopify/getCollectionProducts/reducers';
import getShopifyCollectionVariantCounts from './shopify/getCollectionVariantCounts/reducers';
import getShopifyProductVariants from './shopify/getProductVariants/reducers';
import getLookbookLimits from './lookbooks/getLookbookLimits/reducers';
import getShopifyVariantStock from './shopify/getVariantStock/reducers';

import getBillingOverviewInfo from './billing/overviewInfo/reducers';
import getBillingCreditsBalance from './billing/creditsBalance/reducers';
import billingAddCredits from './billing/addCredits/reducers';
import billingAddCreditsPreview from './billing/addCreditsPreview/reducers';
import getBillingTransactions from './billing/transactions/reducers';
import getBillingInvoices from './billing/invoices/reducers';
import getBillingSubscriptionInfo from './billing/subscriptionInfo/reducers';
import billingSubscriptionUpgrade from './billing/subscriptionUpgrade/reducers';
import billingSubscriptionPortal from './billing/subscriptionPortal/reducers';
import billingSubscriptionModify from './billing/subscriptionModify/reducers';
import billingSubscriptionCancel from './billing/subscriptionCancel/reducers';

import getCodes from './codes/codesList/reducers';
import getCodesProductsListScroll from './codes/productsListScroll/reducers';
import getCodesCollectionsListScroll from './codes/collectionsListScroll/reducers';
import createCodeBasic from './codes/codeCreateBasic/reducers';
import createCodeBxgy from './codes/codeCreateBxgy/reducers';
import createCodeShipping from './codes/codeCreateShipping/reducers';
import activateCode from './codes/codeActivate/reducers';
import activateCodeBulk from './codes/codeActivateBulk/reducers';
import deactivateCode from './codes/codeDeactivate/reducers';
import deactivateCodeBulk from './codes/codeDeactivateBulk/reducers';
import deleteCode from './codes/codeDelete/reducers';
import deleteCodeBulk from './codes/codeDeleteBulk/reducers';
import assignCode from './codes/codeAssign/reducers';
import getCodeRandom from './codes/codeGetRandom/reducers';
import getShippingCodeRandom from './codes/codeShippingGetRandom/reducers';
import getCodeDetails from './codes/codeGetDetails/reducers';
import manageCodeContext from './codes/manageCodeContext/reducers';
import editCode from './codes/codeEdit/reducers';

import getReimbursements from './reimbursements/reimbursementsList/reducers';
import createReimbursement from './reimbursements/createReimbursement/reducers';
import checkReimbursementBalance from './reimbursements/checkBalance/reducers';
import endReimbursements from './reimbursements/endReimbursements/reducers';
import reimbursementManageFlow from './reimbursements/manageFlow/reducers';

import getLookbooks from './lookbooks/lookbooksList/reducers';
import createLookbook from './lookbooks/createLookbook/reducers';
import updateLookbook from './lookbooks/updateLookbook/reducers';
import updateLookbookPublished from './lookbooks/updateLookbookPublished/reducers';
import getLookbook from './lookbooks/getLookbook/reducers';
import lookbookManageFlow from './lookbooks/manageFlow/reducers';
import addLookbookUsers from './lookbooks/addLookbookUsers/reducers';
import deleteLookbook from './lookbooks/deleteLookbook/reducers';
import getLookbookSummary from './lookbooks/lookbookSummary/reducers';
import getLookbookUsers from './lookbooks/lookbookUsers/reducers';

import getLookbookOrder from './lookbooks/orders/getLookbookOrder/reducers';
import updateLookbookOrder from './lookbooks/orders/updateLookbookOrder/reducers';
import getLookbookOrderItem from './lookbooks/orders/getLookbookOrderItem/reducers';
import updateLookbookOrderItem from './lookbooks/orders/updateLookbookOrderItem/reducers';
import handoffLookbookOrderShopify from './lookbooks/orders/handoffLookbookOrderShopify/reducers';
import markLookbookOrderPlaced from './lookbooks/orders/markLookbookOrderPlaced/reducers';
import createLookbookOrderFulfillment from './lookbooks/orders/createLookbookOrderFulfillment/reducers';
import updateLookbookOrderFulfillment from './lookbooks/orders/updateLookbookOrderFulfillment/reducers';
import updateLookbookOrderFulfillmentPackage from './lookbooks/orders/updateLookbookOrderFulfillmentPackage/reducers';
import detectTrackingCarrier from './lookbooks/tracking/detectCarrier/reducers';

import getLinkMeta from './links/getMeta/reducers';
import uploadLinkPreview from './uploadImage/reducers';

export default combineReducers({
  ...splitAuthReducers,
  getSendbirdToken,
  createSendbirdGroup,
  sendbirdUnreadMessages,

  dashboard,
  home,
  performanceSnapshot,
  newArrivals,
  recommendedCreators,
  topPerformers,

  merchants,
  merchantsCreate,
  merchantsVerify,
  merchantsEdit,
  analyticsLinksReport,
  analyticsCampaignModifiers,
  analyticsUsersReport,
  creatorDetails,
  chatCreatorDetails,
  similarCreators,
  creatorSignals,
  creatorMonthlySales,
  creatorNotes,
  discover,
  discoverBrands,
  discoverCategories,
  discoverLinkCategories,
  dataExports,
  members,
  invitations,
  membersInvite,
  organizationContact,
  account,
  accountNameEdit,
  accountEmailEdit,
  accountPhoneEdit,
  accountPhoneVerify,
  accountPasswordReset,
  help,
  notifications,
  swagger,
  settings,
  layout,
  aiAssistant,
  aiChatToken,
  aiPromptSuggestions,
  pricingModal,
  acceptInvitationSignUp,
  avatar,
  referralsLink,
  referralsConnections,
  referralsInvite,
  stripeBilling,
  verifiedDomains,
  getUnmaskingConnection,
  getUnmaskingConnections,
  getUnmaskingInvitation,
  getUnmaskingInvitations,
  withdrawUnmaskingInvitation,
  sendUnmaskingInvitation,
  sendUnmaskingInvitationBulk,

  getRegularusersGroups,
  createRegularusersGroup,
  updateRegularusersGroup,
  deleteRegularusersGroup,
  getRegularusersGroup,
  getAssignments,
  getAssignment,
  createAssignment,
  checkAssignmentBalance,
  updateAssignment,
  deleteAssignment,
  archiveAssignment,
  publishAssignment,
  uniqueAssignmentName,
  getAssignmentSummary,
  getAssignmentCreatorsPerformance,
  baseCommissionRate,
  networkMerchant,
  getNetworkOrders,
  getNetworkOrdersSummary,
  networkOrderDetail,
  commissionRules,
  campaignCreateFlow,
  campaignEditFlow,

  getPromotions,
  createPromotion,
  getPromotion,
  updatePromotion,
  deletePromotion,

  getMyCreatorsConnectedList,
  getMyCreatorsConnectedListScroll,

  getMyCreatorsGroupsList,

  createGroup,
  updateGroup,
  groupFlow,
  deleteGroup,
  addGroupUsers,
  getGroupUsersList,
  removeGroupUsers,

  createSmartGroup,
  updateSmartGroup,
  refreshSmartGroup,
  smartGroupFlow,
  deleteSmartGroup,

  batchMessage,

  sendSendbirdBatchMessage,
  getSendbirdBatchMessageInfo,
  retrySendbirdBatchMessage,
  getSendbirdBatchMessages,

  getBatchMessageVariables,

  createBatchMessageTemplate,
  updateBatchMessageTemplate,
  removeBatchMessageTemplate,
  getBatchMessageTemplates,

  performanceLinks,
  performanceTags,
  performanceCreators,
  performanceExports,
  performanceSummaryCards,
  performanceSummaryChart,

  createShopifyToken,
  getShopifyTokens,
  getShopifyToken,
  getShopifyStatus,
  getShopifyProducts,
  getShopifyCollections,
  getShopifyProductTypes,
  getShopifyCollectionProducts,
  getShopifyCollectionVariantCounts,
  getShopifyProductVariants,
  getLookbookLimits,
  getShopifyVariantStock,

  getBillingOverviewInfo,
  getBillingCreditsBalance,
  billingAddCredits,
  billingAddCreditsPreview,
  getBillingTransactions,
  getBillingInvoices,
  getBillingSubscriptionInfo,
  billingSubscriptionUpgrade,
  billingSubscriptionPortal,
  billingSubscriptionModify,
  billingSubscriptionCancel,

  getCodes,
  getCodesProductsListScroll,
  getCodesCollectionsListScroll,
  createCodeBasic,
  createCodeBxgy,
  createCodeShipping,
  getCodeRandom,
  getShippingCodeRandom,
  getCodeDetails,
  manageCodeContext,
  activateCode,
  activateCodeBulk,
  deactivateCode,
  deactivateCodeBulk,
  deleteCode,
  deleteCodeBulk,
  assignCode,
  editCode,

  getReimbursements,
  createReimbursement,
  checkReimbursementBalance,
  endReimbursements,
  reimbursementManageFlow,

  getLookbooks,
  createLookbook,
  updateLookbook,
  updateLookbookPublished,
  getLookbook,
  lookbookManageFlow,
  addLookbookUsers,
  deleteLookbook,
  getLookbookSummary,
  getLookbookUsers,

  getLookbookOrder,
  updateLookbookOrder,
  getLookbookOrderItem,
  updateLookbookOrderItem,
  handoffLookbookOrderShopify,
  markLookbookOrderPlaced,
  createLookbookOrderFulfillment,
  updateLookbookOrderFulfillment,
  updateLookbookOrderFulfillmentPackage,
  detectTrackingCarrier,

  getLinkMeta,
  uploadLinkPreview
});
